import Constants from "../utils/consts";
import Cookies from "universal-cookie";

const REQUEST_TIMEOUT = 60000; // 1 minuto per GET

function getDbName() {
  try {
    return new Cookies().get("db", { path: "/" });
  } catch (error) {
    console.warn("[getEvento] Impossibile leggere il cookie db:", error);
    return undefined;
  }
}

export default async function getEvento(uname, token, id) {
  return new Promise(function(resolve, reject) {
    const db = getDbName();
    const endpoint = `${Constants.mainUrl}getEvento.php`;

    const xhr = new XMLHttpRequest();
    xhr.timeout = REQUEST_TIMEOUT;

    xhr.onload = function() {
      console.log("[getEvento] response status:", xhr.status);

      if (xhr.status === 200) {
        try {
          const resp = JSON.parse(xhr.responseText);
          resolve(resp);
        } catch (error) {
          console.error("[getEvento] Error parsing response:", error);
          console.error("[getEvento] Response text:", xhr.responseText);
          reject({
            error: "PARSE_ERROR",
            message: "Risposta del server non valida",
            details: xhr.responseText,
          });
        }
      } else {
        reject({
          error: "HTTP_ERROR",
          status: xhr.status,
          message: "Errore dal server",
          details: xhr.responseText,
        });
      }
    };

    xhr.onerror = function(event) {
      console.error("[getEvento] network error:", event);
      reject({
        error: "NETWORK_ERROR",
        message: "Errore di rete",
      });
    };

    xhr.ontimeout = function() {
      console.error("[getEvento] timeout");
      reject({
        error: "TIMEOUT",
        message: "Timeout durante il caricamento",
      });
    };

    const params = new URLSearchParams();
    params.append("token", token);
    params.append("uname", uname);
    if (db) params.append("db_name", db);
    params.append("id_evento", id);

    console.log("[getEvento] sending request for id:", id);

    xhr.open("POST", endpoint, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(params.toString());
  });
}
